import {
    SET_TASK_ID
} from '../../actions';

const initialState = {
    id: null
}

function taskIdReducer(state = initialState, action ) {
    const newState = {};

    switch (action.type) {
        case SET_TASK_ID:
            newState.id = action.id;
            return newState;
        
        default:
            return state;

    }
 
}

export default taskIdReducer;
